import HomeIcon from '@mui/icons-material/Home'
import SearchIcon from '@mui/icons-material/Search'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'
import NotificationBadge from 'components/Page/SideMenu/NotificationBadge'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import GroupsIcon from '@mui/icons-material/Groups'

export const menuIcons = {
    Home: <HomeIcon />,
    MyDances: <SelfImprovementIcon />,
    MyRequests: <NotificationBadge />,
    Search: <SearchIcon />,
    MyOrganizations: <GroupsIcon />,
    allMediaRequests: <HourglassEmptyIcon />,
}

export const menuActions = {
    Home: (navigate) => navigate('/'),
    MyDances: (navigate) => navigate('/myDances'),
    MyRequests: (navigate) => navigate('/myRequests'),
    Search: (navigate) => navigate('/advancedSearch'),
    MyOrganizations: (navigate) => navigate('/myOrganizations'),
    allMediaRequests: (navigate) => navigate('/allMediaRequests'),
}

export const menuItems = [
    'Home',
    'MyDances',
    'MyRequests',
    'Search',
    'MyOrganizations',
]
export const menuItemsSuperAdmin = [...menuItems, 'allMediaRequests']
